import { render, staticRenderFns } from "./RUApprovalDialog.vue?vue&type=template&id=45144d9f&scoped=true"
import script from "./RUApprovalDialog.vue?vue&type=script&lang=js"
export * from "./RUApprovalDialog.vue?vue&type=script&lang=js"
import style0 from "./RUApprovalDialog.vue?vue&type=style&index=0&id=45144d9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45144d9f",
  null
  
)

export default component.exports